import axios from 'axios';

const baseURL = process.env.REACT_APP_CARE_API_URL;

const client = axios.create({ baseURL });

const ResponseInterceptor = async response => {
	return Promise.resolve({ data: response.data.data });
};

const ErrorInterceptor = error => {
	return Promise.resolve({
		error: error?.response?.data || error?.message
	});
};

client.interceptors.response.use(ResponseInterceptor, ErrorInterceptor);

export default client;
